export type ChipRole = 'token' | 'separator' | 'custom';

const TOKEN_PATTERN = /^\{([^{}]+)\}$/;
const SUPPORTED_SEPARATORS: readonly string[] = ['_', '-', '.'];

export function classifyChip(value: string): ChipRole {
  if (TOKEN_PATTERN.test(value)) return 'token';
  if (value.length === 1 && SUPPORTED_SEPARATORS.includes(value)) return 'separator';
  return 'custom';
}

export function chipLabelOf(value: string): string {
  const match = TOKEN_PATTERN.exec(value);
  return match ? match[1] : value;
}
